import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import CartSheet from "./components/CartSheet";
import ChatWidget from "./components/ChatWidget";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Success from "./pages/Success";
import About from "./pages/About";
import Account from "./pages/Account";
import Orders from "./pages/Orders";
import AuthCallback from "./pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Synchronous check (NOT useEffect) — process session_id BEFORE other routing/auth checks
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <CartSheet />
      <ChatWidget />
      <main className="min-h-[60vh]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/success" element={<Success />} />
          <Route path="/about" element={<About />} />
          <Route path="/account" element={<Account />} />
          <Route path="/orders" element={<Orders />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <AppRouter />
              <Toaster
                position="top-center"
                toastOptions={{
                  style: {
                    background: "#FFFDF0",
                    border: "3px solid #0A0A0A",
                    color: "#0A0A0A",
                    fontWeight: 600,
                    boxShadow: "4px 4px 0 0 #0A0A0A",
                  },
                }}
              />
            </BrowserRouter>
          </CartProvider>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

export default App;
